
























































import { Vue, Component, Emit, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { performanceServer, panoramicQueryServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';
import BusinessInformationPage from '@/views/enterpriseSubjectInformation/businessManagement/unit/businessInformationPage.vue';
const serverUrl = publishObjectPath.serverUrl;

@Component({
  components: { BusinessInformationPage, PagingUnit, CollapseTransition },
  mixins: [TableStripe],
})
export default class LawsRegulations extends Vue {
  private showPublicPage = false;
  private row: any = '';
  private type: any = '';
  private tableLoading = false; // loading...
  private tableData: any = []; // 表格数据
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private searchForm: any = {
    searchValue: '',
  };
  private total = 0;
  private classificationList: any = [];

  private uploadUrl: any = publishObjectPath.serverUrl + '/api/yunnan/company/importExcel';
  headers: any = {};
  fileList: any = [];
  private importLoading: any = false;

  mounted() {
    this.headers.Authorization = localStorage.getItem('token');
  }

  created() {
    this.searchForm.searchValue = this.$route.params.name;
    this.getTableData();
  }
  private downloadTemplate() {
    window.location.href = publishObjectPath.imgPathWater + `/doc/企业导入模版.xlsx`;
  }
  private handleAvatarCardFrontSuccess(file: any) {
    this.importLoading = true;
    if (file.code === '200') {
      this.$message.success('导入成功！');
      this.importLoading = false;
      this.getTableData();
    } else {
      this.$message.warning(file.msg);
      this.importLoading = false;
    }
    this.fileList = [];
  }
  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
  }

  private backToRiskPage() {
    this.showPublicPage = false;
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }

  private getTableData() {
    this.tableLoading = true;
    panoramicQueryServer
      .getInfoList({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        searchValue: this.searchForm.searchValue,
      })
      .then((res: any) => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.$message.warning(res.data.msg);
        }
      });
  }

  private jumpToPublicPage(type: any, data: any) {
    this.row = data;
    this.type = type;
    switch (type) {
      case 'add':
        this.showPublicPage = true;
        break;
      case 'detail':
        this.showPublicPage = true;
        break;
      case 'edit':
        this.showPublicPage = true;
        break;
      case 'delete':
        this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.deleteLawsRegulations(data.id);
          })
          .catch(() => {
            this.$message.info('已取消删除');
          });
        break;
    }
  }

  // 删除
  private deleteLawsRegulations(id: any) {
    panoramicQueryServer.deleteAccident(id).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('删除成功');
        this.getTableData();
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private onSearch() {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }
}
